import type { StateCreator } from 'zustand';
import type { Language } from '@siloreal:shared:sdk/locale';

export type UserSlice = {
  user_locale: Language;
  user_set_locale: (locale: Language) => void;
};

export const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (set) => ({
  user_locale: 'es',
  user_set_locale: (locale) => set({ user_locale: locale }),
});
